export default "__VITE_ASSET__ba_drf6Y__"